import { ICureFormByStoreDTO, IDosageByStoreDTO, INFvByStoreDTO, IRequestForMovementCreateDTO, IRequestForMovementEditDTO, IRequestForMovementGetDTO, IRequestForMovementViewDTO } from "../../coreapi-dto/documents/requestForMovement"
import { IRequestForMovementItemGetDTO, IRequestForMovementItemViewDTO } from "../../coreapi-dto/documents/requestForMovementItem"
import { ContentType } from "../../fetchApiDistributor/contentTypes"
import { CoreApiResponse, IRequestEventHandler } from "../common"
import { BaseDocRequestV2 } from "../documents/baseDocRequestV2"
export class RequestForMovementRequest extends BaseDocRequestV2<
    IRequestForMovementViewDTO,
    IRequestForMovementGetDTO,
    IRequestForMovementCreateDTO,
    IRequestForMovementEditDTO,
    IRequestForMovementItemViewDTO,
    IRequestForMovementItemGetDTO
> {
    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "RequestForMovement", token, eventHandler)
    }

    cancel(idGlobal: string, callback: (e: CoreApiResponse<null>) => void) {
        super.patch(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/Cancel`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e)
        })
    }

    done(idGlobal: string, callback: (e: CoreApiResponse<null>) => void) {
        super.patch(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/Done`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e)
        })
    }

    sent(idGlobal: string, callback: (e: CoreApiResponse<null>) => void) {
        super.patch(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/Sent`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e)
        })
    }
    
    getDistinctCureFormViewByStore(body: IViewBody, callback: (e: CoreApiResponse<IViewWrapper<ICureFormByStoreDTO>>) => void, signal?: AbortSignal | null) {        
        this.post<IViewWrapper<ICureFormByStoreDTO>>(`${this._baseUrl}/${this._routePrefix}/DistinctCureFormViewByStore`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        }, signal)
    }

    getDistinctNFvViewByStore(body: IViewBody, callback: (e: CoreApiResponse<IViewWrapper<INFvByStoreDTO>>) => void, signal?: AbortSignal | null) {        
        this.post<IViewWrapper<INFvByStoreDTO>>(`${this._baseUrl}/${this._routePrefix}/DistinctNFvViewByStore`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        }, signal)
    }

    getDistinctDosageViewByStore(body: IViewBody, callback: (e: CoreApiResponse<IViewWrapper<IDosageByStoreDTO>>) => void, signal?: AbortSignal | null) {        
        this.post<IViewWrapper<IDosageByStoreDTO>>(`${this._baseUrl}/${this._routePrefix}/DistinctDosageViewByStore`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        }, signal)
    }

    remains (filter: IDistinctByStoreFilterData, callback: (e) => void) {
        this.post(
        `${this._baseUrl}/${this._routePrefix}/Remains`, filter,
        this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
        (e) => {
            if (this._eventHandler) {
            if (e.respType === 'isFailed') {
                this._eventHandler.onGetResponse(e);
            }
            }
            callback(e);
        }
        );
    }
}

export default RequestForMovementRequest
